import apartment01 from "./assets/images/apartment-01.jpg";
import apartment02 from "./assets/images/apartment-02.jpg";
import apartment03 from "./assets/images/apartment-03.jpg";
import apartment04 from "./assets/images/apartment-04.jpg";
import apartment05 from "./assets/images/apartment-05.jpg";
import apartment06 from "./assets/images/apartment-06.jpg";
import apartment07 from "./assets/images/apartment-07.jpg";
import apartment08 from "./assets/images/apartment-08.jpg";
import apartment09 from "./assets/images/apartment-09.jpg";
import apartment10 from "./assets/images/apartment-10.jpg";
import commercial01 from "./assets/images/commercial-01.jpg";
import commercial02 from "./assets/images/commercial-02.jpg";
import commercial03 from "./assets/images/commercial-03.jpg";
import commercial04 from "./assets/images/commercial-04.jpg";
import commercial05 from "./assets/images/commercial-05.jpg";
import glassHouseImage from "./assets/images/glass-house.jpg";
import house01 from "./assets/images/house-01.jpg";
import house02 from "./assets/images/house-02.jpg";
import house03 from "./assets/images/house-03.jpg";
import house04 from "./assets/images/house-04.jpg";
import house05 from "./assets/images/house-05.jpg";
import house06 from "./assets/images/house-06.jpg";
import house07 from "./assets/images/house-07.jpg";
import house08 from "./assets/images/house-08.jpg";
import land01 from "./assets/images/land-01.jpg";
import land02 from "./assets/images/land-02.jpg";
import land03 from "./assets/images/land-03.jpg";
import modernHouseImage from "./assets/images/modern-house.jpg";
import modernKitchenImage from "./assets/images/modern-kitchen.jpg";
import modernLivingRoomImage from "./assets/images/modern-living-room.jpg";
import todayHeroCityImage from "./assets/images/today-hero-city.jpg";

export const todayHeroImage = todayHeroCityImage;

export const apartmentPropertyImages = [
  modernLivingRoomImage,
  modernKitchenImage,
  apartment01,
  apartment02,
  apartment03,
  apartment04,
  apartment05,
  apartment06,
  apartment07,
  apartment08,
  apartment09,
  apartment10
] as const;

export const housePropertyImages = [
  glassHouseImage,
  modernHouseImage,
  house01,
  house02,
  house03,
  house04,
  house05,
  house06,
  house07,
  house08
] as const;

export const landPropertyImages = [land01, land02, land03] as const;
export const commercialPropertyImages = [commercial01, commercial02, commercial03, commercial04, commercial05] as const;

export const propertyImageSources = [
  ...apartmentPropertyImages,
  ...housePropertyImages,
  ...landPropertyImages,
  ...commercialPropertyImages
] as const;

export const legacyPropertyImagePools = {
  apartment: [modernLivingRoomImage, modernKitchenImage],
  house: [glassHouseImage, modernHouseImage],
  general: [glassHouseImage, modernLivingRoomImage, modernHouseImage, modernKitchenImage]
} as const;
